<template>
	<div class="product product-lightened" :class="productSelector">
		<div class="product--state">
			<img src="@/assets/checked-primary.svg" alt="" />
		</div>
		<Badge :class="{ transparent: !isActive }" v-bind="product.badge" />

		<div class="product-main">
			<div class="product--label" v-html="product.text"></div>
			<div class="product--subtitle" v-html="product.subtitle"></div>
		</div>

		<div class="product-sidebar">
			<div class="sidebar">
				<div class="sidebar--title">{{ product.sidebar_title }}</div>
				<div class="sidebar--subtitle">{{ product.sidebar_note }}</div>
			</div>
		</div>
	</div>
</template>

<script>
import { computed } from '@vue/reactivity'
import Badge from './Badge.vue'

export default {
	props: {
		product: {
			type: Object,
			required: true
		},
		isActive: {
			type: Boolean,
			required: true
		}
	},

	components: { Badge },

	setup(props) {
		return {
			productSelector: computed(() => {
				const classList = ['product', props.theme]
				if (props.isActive) classList.push('active')
				if (props.product.popular) classList.push('popular')
				if (props.product.bage) classList.push('badge')
				return classList
			})
		}
	}
}
</script>

<style scoped lang="scss">
.product {
	background-color: #fff;
	padding: 13px 15px 13px 15px;
	margin-bottom: 1.3rem;
	border-radius: 0.7rem;
	border: 2px solid #f5f5f7;
	transition: border-color 0.3s, background-color 0.3s;
	position: relative;
	padding-left: 3.8rem;
	color: #323653;

	&--popular {
		position: absolute;
		left: -2px;
		font-size: 0.7rem;
		top: 0;
		transform: translateY(-50%);
		background-color: #7d8bf7;
		color: #fff;
		font-weight: 500;
		padding: 0.1rem 1rem;
		border-radius: 3px;
	}

	&.badge {
		padding-right: 6.5rem;
	}

	&:last-child {
		margin-bottom: 0;
	}

	&--label {
		font-weight: bold;
		font-size: 1.1rem;
		line-height: 1.3;
	}

	&--subtitle {
		margin-top: 0.3rem;
		opacity: 0.9;
		font-size: 0.9rem;
		line-height: 1.3;
	}

	&--state {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translateY(-50%);
		width: 22px;
		height: 22px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 50%;
		border: 1px solid #e2e2e5;
		transition: background-color 0.3s, border-color 0.3s;

		img {
			width: 12px;
			opacity: 0;
			transition: opacity 0.3s;
		}
	}

	&.active {
		background-color: #7d8bf7;
		border-color: #7d8bf7;
		color: #fff;
	}

	&.active & {
		&--state {
			background-color: #fff;
			border-color: #fff;

			img {
				opacity: 1;
			}
		}
	}

	&.popular {
		padding-top: 16px;
	}
}

.sidebar {
	text-align: right;

	&--title {
		font-weight: 700;
		font-size: 1.3rem;
		line-height: 1.2;
	}

	&--note {
		font-size: 0.9rem;
	}
}
</style>
